import type { MultipleBetType } from '@ps/isp-web-services-types';
import React from 'react';

import type { MultipleReceiptItem } from '@swf/core/models/sports/betSlip/types';
import { getIsSgmOpportunity } from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { ExpandablePanel } from '@swf/sports/components';
import { generateRunnerKey } from '@swf/sports/utils/generateRunnerKey';

import BetDetails from '../BetDetails/BetDetails';
import StakeAndReturns from '../StakeAndReturns/StakeAndReturns';

import styles from './MultipleAccordion.scss';
import SgmReceiptItem from './components/SgmReceiptItem/SgmReceiptItem';
import Title from './components/Title/Title';

const MultipleAccordion: React.FC<MultipleReceiptItem> = (receiptItem) => {
  const isSgmOpportunity = getIsSgmOpportunity(receiptItem);

  return (
    <ExpandablePanel
      isOpenInitially={false}
      title={
        <Title
          {...receiptItem}
          type={receiptItem.type as MultipleBetType}
          isSgm={isSgmOpportunity}
          isEachWaySelected={receiptItem.eachWaySelected}
        />
      }
      className={styles.panel}
    >
      <div className={styles.contentWrapper}>
        {isSgmOpportunity ? (
          <SgmReceiptItem receiptItem={receiptItem} />
        ) : (
          <div className={styles.runners}>
            {receiptItem.runners?.map((runner) => (
              <div
                key={generateRunnerKey({
                  selectionId: runner.selectionId,
                  marketId: runner.marketId
                })}
                className={styles.runner}
              >
                <BetDetails
                  {...runner}
                  isEventInPlay={runner.eventInPlay}
                  odds={runner.winRunnerOdds}
                  isEachWaySelected={receiptItem.eachWaySelected}
                />
              </div>
            ))}
          </div>
        )}
        <StakeAndReturns receiptItem={receiptItem} />
      </div>
    </ExpandablePanel>
  );
};

export default MultipleAccordion;
